import { render, staticRenderFns } from "./interestPopu.vue?vue&type=template&id=95dfc846&"
import script from "./interestPopu.vue?vue&type=script&lang=js&"
export * from "./interestPopu.vue?vue&type=script&lang=js&"
import style0 from "./interestPopu.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports